
import HeaderMobileMenu from "./HeaderMobileMenu";
export default {
    name: "HeaderMobile",
    components: {HeaderMobileMenu},
    data() {
        return {
        }
    },
}
